import { render, staticRenderFns } from "./TableHeadNote.vue?vue&type=template&id=2b263e10&scoped=true"
import script from "./TableHeadNote.vue?vue&type=script&lang=js"
export * from "./TableHeadNote.vue?vue&type=script&lang=js"
import style0 from "./TableHeadNote.vue?vue&type=style&index=0&id=2b263e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b263e10",
  null
  
)

export default component.exports